import React, {useEffect, useRef} from "react";
import {WrappedItem} from "BaseComponents/Wrappers";
import {H4} from "BaseComponents/Text";
import styled from "styled-components";
import CountUp from 'react-countup';
import breakpoints from "Helpers/BreakpointHelper";
import media from "styled-media-query";
import {useGlobal} from "reactn";

export const CountingNumberItem = ({Heading, Value, Unit, Sign}) => {
    const [theme] = useGlobal("theme");
    return (
        <WrappedItem
            justifyContent="space-between"
            margin="0"
            padding="0"
            alignItems="center"
        >
            <TopWrapper>
                <NumberWrapper theme={theme}>
                    <CountUp stat={0} end={Value} duration={3} enableScrollSpy={true} scrollSpyDelay={100}/>
                    {!!Unit && <span>{Unit}</span>}
                    {!!Sign && <span>{Sign}</span>}
                </NumberWrapper>
                <H4 fontWeight={700}>{Heading}</H4>
            </TopWrapper>

        </WrappedItem>
    );
};
const TopWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
`;

const NumberWrapper = styled.div.attrs(
    ({
         theme
     }) => ({
        primary: theme.colors.primary
    })
)`
  display: flex;
  align-items: center;
  align-items: center;
  gap: 5px;
  span {
    font-size: 52px;
    font-weight: 500;
    color: ${({primary}) => primary};
  }
  ${media.greaterThan(breakpoints.mobile)`
       
    `}
`;
